<template>
    <service-screen-layout :parts="parts">
        <template v-slot:usage>
            <PrivateMtnApnUsage :apnUsageNumber="saleDefinition.definition.usage.apnUsageNumber" />
        </template>
    </service-screen-layout>
</template>

<script>
import ServiceScreenLayout from '@/layouts/ServiceScreenLayout.vue';
import PrivateMtnApnUsage from '@/components/ObjParts/SingleCaptured/PrivateMtnApnUsage.vue';

    export default {
        components: {
            ServiceScreenLayout,
            PrivateMtnApnUsage
        },
        data() {
            return {
                parts: [
                    {
                        name: "usage",
                        icon: "fa fa-chart-simple",
                        displayName: "Usage Data",
                        permissions: ["*"],
                    },
                ],
                saleNumber: null,
                saleDefinition: {
                    definition: {
                        usage: {
                            apnUsageNumber: 0
                        }
                    }
                }
            }
        },
        mounted() {
            this.saleNumber = this.$root.$route.params.saleNumber;
            this.getSaleDefinition();
        },
        methods: {
            getSaleDefinition: function() {
                const hostUrl = this.$config.aimsAPI;

                this.$http.get(`${hostUrl}sales/definition/sale/${this.saleNumber}`).then(
                    (response) => {
                        this.saleDefinition = response.data;
                    },
                    (error) => {
                        console.error(error);
                        this.showError("Error fetching Sale Definition", error);
                    }
                )
            }
        }
    }
</script>
